import { render, staticRenderFns } from "./count-down.vue?vue&type=template&id=2b1fce1b&scoped=true&"
import script from "./count-down.vue?vue&type=script&lang=js&"
export * from "./count-down.vue?vue&type=script&lang=js&"
import style0 from "./count-down.vue?vue&type=style&index=0&id=2b1fce1b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1fce1b",
  null
  
)

export default component.exports